import React, { useCallback, useEffect, useLayoutEffect } from 'react';
import Animated from 'react-native-reanimated';
import { useAppDispatch } from 'store/hooks';
import { AppView, Button, ButtonGroup } from 'design-system';
import { HEIGHT } from 'design-system/Button';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import InfoCardWithIndex from 'design-system/InfoCardWithIndex';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { rem, SCROLL_INDICATOR_INSETS } from 'design-system/values';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { HELP_ARTICLES_KEY } from 'features/help/constants';
import { getConnectedAccount } from 'actions/invest';
import Amplitude from 'utils/amplitude';
const AutosaveIntro = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const dispatch = useAppDispatch();
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const contentContainerStyle = useMarginBottom('paddingBottom', HEIGHT + rem(16), paddingHorizontalStyle);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton articlesKey={HELP_ARTICLES_KEY.AUTOSAVE_ONBOARDING}/>,
        });
    }, []);
    useEffect(() => {
        Amplitude.logEvent('How Direct Debit Works', { source: 'save' });
        dispatch(getConnectedAccount());
    }, []);
    const handleContinue = useCallback(() => {
        navigation.navigateDeprecated('AutosaveSaveMoneyIntro');
    }, []);
    return (<AppView type="secondary" withFrame={false}>
        <Animated.ScrollView scrollEventThrottle={16} onScroll={scrollHandler} contentContainerStyle={contentContainerStyle} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          <ScreenInfoHeader title="How autosave works:" preTitle="You’re all set for success!" subTitle="Customers who set up autosave in Emma save 10x more!"/>
          <InfoCardWithIndex index={1} title="Set up autosave" subTitle="Choose the bank account from which you want to save and setup a direct debit"/>
          <InfoCardWithIndex index={2} title="Pick your saving rules" subTitle="Round up your change, choose an amount you want to save or let Emma calculate the perfect amount for you!"/>
          <InfoCardWithIndex index={3} title="Stay in control" subTitle="You can pause autosave at any time or skip upcoming payments. We will always notify you 24 hours in advance"/>
        </Animated.ScrollView>
        <ButtonGroup type="floating">
          <Button brand title="Continue" onPress={handleContinue}/>
        </ButtonGroup>
      </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default AutosaveIntro;
